import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/E3_360.svg"

const E3360: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 36 37'} component={Icon} {...props} fill="currentColor" />
export default E3360
